import api from "@/config/api";
import { API_ENDPOINTS } from "@/constants/api-endpoints";
import type { StockAvailabilityResponseDTO } from "../types/stock.types";

interface AvailabilityParams {
  stockIds?: number[];
  barcodes?: string[];
  startDate: string;
  endDate: string;
}

export const stockAvailabilityService = {
  getAvailability: async (
    params: AvailabilityParams,
  ): Promise<StockAvailabilityResponseDTO[]> => {
    const response = await api.get<StockAvailabilityResponseDTO[]>(
      API_ENDPOINTS.STOCKS_USER.AVAILABILITY,
      { params },
    );
    return response.data;
  },
};
